import { MatMenuModule } from "@angular/material/menu";
import { NgTemplateOutlet } from "@angular/common";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { Component, TemplateRef, ViewEncapsulation, input, output } from "@angular/core";

import { ButtonComponent } from "../button/button.component";

import { MenuItem } from "src/app/core/interfaces";

@Component({
  selector: "app-menu",
  standalone: true,
  imports: [NgTemplateOutlet, RouterLink, RouterLinkActive, MatMenuModule, ButtonComponent],
  templateUrl: "./menu.component.html",
  styleUrl: "./menu.component.scss",
  encapsulation: ViewEncapsulation.None,
})
export class MenuComponent {
  readonly menuItems = input.required<MenuItem[]>();
  readonly menuItemTemplateRef = input.required<TemplateRef<unknown>>();
  readonly color = input<"primary" | "accent" | "warn" | null>(null);
  readonly btnLabel = input<string>();
  readonly btnClass = input<string>();
  readonly menuClass = input<string>();
  readonly backdropClass = input<string>("ahmed");
  readonly menuTemplateRef = input<TemplateRef<unknown>>();

  readonly onMenuClosed = output();
  readonly onMenuOpened = output();
}
